'use client';
import { routes } from '~constants/routes';
import { usePathname } from '~i18n/navigation';

export const useSluggedPathname = () => {
	let pathname = usePathname();
	let sluggedPathname = pathname;

	const dialogsMatch = pathname.match(/^\/chats\/[^\/]+$/);
	if (dialogsMatch) {
		pathname = routes.chats.home;
		sluggedPathname = routes.chats.dialog('{botId}');
	}
	const profileMatch = pathname.match(/^\/profile\/[^\/]+$/);
	if (profileMatch) {
		pathname = routes.profile.home;
		sluggedPathname = routes.profile.slug('{botId}');
	}
	//for promo event we count /characters/* as / as both contain grid
	const charactersMatch = pathname.startsWith(routes.explore.models);
	if (charactersMatch) {
		pathname = routes.explore.home;
		sluggedPathname = routes.explore.home;
	}
	return [pathname, sluggedPathname];
};
